import React, { useEffect, useMemo } from 'react';
import MainAppTemplate from '../components/MainAppTemplate';
import Routes from './routes';
import { Chip } from "@mui/material";
import { useLevels } from "@dyl/systems/LevelsManager";
import useUrlLevel from "@dyl/hooks/useUrlLevel";

const navLinks = [
	{
		type: 'Link',
		allowedRoles: ['DYLE_ADMIN','DYLE_CONTENT','DYLE_SUPPORT'],
		slug: ({ currentPath }) => `/level_select?from=${currentPath}`,
		title: ({ level_label } ) =>
			<>
				Level Select
				<Chip size='small' variant='outlined' label={level_label} style={{ marginLeft: '4px' }} />
			</>
	},
	{
		type: 'Divider',
		allowedRoles: ['DYLE_ADMIN','DYLE_CONTENT','DYLE_SUPPORT'],
	},
	{
		type: 'Link',
		allowedRoles: ['DYLE_ADMIN','DYLE_CONTENT'],
		slug: ({ level_label }) => `/${level_label}/tests`,
		title: 'Tests',
	},
	{
		type: 'Link',
		allowedRoles: ['DYLE_ADMIN','DYLE_CONTENT'],
		slug: ({ level_label }) => `/${level_label}/components`,
		title: 'Components',
	},
	{
		type: 'Link',
		allowedRoles: ['DYLE_ADMIN','DYLE_CONTENT'],
		slug: ({ level_label }) => `/${level_label}/tasks`,
		title: 'Tasks'
	},
	{
		type: 'Link',
		allowedRoles: ['DYLE_ADMIN','DYLE_CONTENT'],
		slug: ({ level_label }) => `/${level_label}/tasks/anchor`,
		title: 'Anchor Tasks'
	},
	{
		type: 'Link',
		allowedRoles: ['DYLE_ADMIN','DYLE_CONTENT'],
		slug: ({ level_label }) => `/${level_label}/rubrics`,
		title: 'Rubrics',
	},
	{
		type: 'Link',
		allowedRoles: ['DYLE_ADMIN','DYLE_CONTENT','DYLE_SUPPORT'],
		slug: ({ level_label }) => `/${level_label}/passwords`,
		title: 'Passwords',
	},
	{
		type: 'Link',
		allowedRoles: ['DYLE_ADMIN','DYLE_CONTENT'],
		slug: ({ level_label }) => `/${level_label}/misspelling-words`,
		title: 'Misspelling Words',
	},
	{
		type: 'Link',
		allowedRoles: ['DYLE_ADMIN','DYLE_CONTENT'],
		slug: ({ level_label }) => `/${level_label}/arc-automarker-template`,
		title: 'ARC AI Automarker template',
	},
	{
		type: 'Divider',
		allowedRoles: ['DYLE_ADMIN','DYLE_CONTENT']
	},
	{
		type: 'Link',
		allowedRoles: ['DYLE_ADMIN','DYLE_CONTENT'],
		slug: ({ level_label }) => `/${level_label}/medias`,
		title: 'Image and Audio files',
	},
	{
		type: 'Link',
		allowedRoles: ['DYLE_ADMIN','DYLE_CONTENT'],
		slug: ({ level_label }) => `/${level_label}/amtt`,
		title: 'Automarker Target Templates',
	},
];



export const Layout = () => {
	// Set globalLevel based on the URL, wait for getLevels() call via LevelsManager
	// We can circumvent this if we hardcode A1 level uuid and label
	// This was a design flaw - had to use level uuid in the url scheme
	const { urlLevel } = useUrlLevel();
	const { levels, levelsStatus, globalLevel, setGlobalLevel } = useLevels();

	const urlLevelLoaded = useMemo(() => {
		if (levelsStatus === 'not started' || levelsStatus === 'loading') return;

		return urlLevel === null || urlLevel.toLowerCase() === globalLevel.label.toLowerCase();
	},[urlLevel, globalLevel, levelsStatus]);

	useEffect(() => {
		if (!urlLevelLoaded) {
			setGlobalLevel(levels.filter(x => x.label.toLowerCase() === urlLevel.toLowerCase())[0]);
		}
	}, [urlLevelLoaded]);

	return (
		<MainAppTemplate navLinks={navLinks}>
			<Routes />
		</MainAppTemplate>
	);
};
